import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const sellerStatus = v.union(v.literal("active"), v.literal("inactive"));

export const validatorSeller = v.object({
  fullName: v.optional(v.string()),
  email: v.optional(v.string()),
  phone: v.optional(v.string()),
  address: v.optional(v.string()),
  commissionRate: v.optional(v.number()),
  userId: v.optional(v.id("users")),

  internalControl: internalControl,
});
export const sellers = defineTable(validatorSeller)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_user_id", ["userId"])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
